export default function headerButton() {
  const widgetName = 'headerButtonWidget';
  const widgetOpts = headerButtonWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const URL = data.items[0]?.URL !== null;
      if (hasData && URL) return;
      $widgetHTML.parent().remove();
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
